import type { DocMigration } from "../docMigration";

interface MigrationRailingJson {
  useNewRailingTerminationLogic?: boolean;
}

interface MigrationDocJson {
  railings?: Record<string, MigrationRailingJson>;
}

const migration: DocMigration = {
  id: "20260812_railing_termination_logic",
  description: "Set useNewRailingTerminationLogic to false on all existing railings",
  apply(json: MigrationDocJson): MigrationDocJson {
    const railings = json.railings ?? {};
    for (const railing of Object.values(railings)) {
      railing.useNewRailingTerminationLogic = false;
    }
    return json;
  },
};

export default migration;
